import { Button, VisuallyHiddenInput } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { UploadIcon } from 'components/icons';
import React, { useRef } from 'react';

type Props = {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
};

const AttachmentUploadButton = ({ onChange }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <>
      <Button
        onClick={() => {
          inputRef.current?.click();
        }}
        leftIcon={<UploadIcon />}
      >
        {t`Add media or files`}
      </Button>
      <VisuallyHiddenInput
        ref={inputRef}
        type="file"
        onChange={async (event) => {
          await onChange(event);
          event.target.value = '';
        }}
        multiple
      />
    </>
  );
};

export default AttachmentUploadButton;
